type Options = Partial<ProductComingSoonCountdownOptions>;

export interface ProductComingSoonCountdownOptions {
  dataKey: string;
  daysSelector: string;
  hoursSelector: string;
  rootSelector: string;
  rootTitleSelector: string;
  minutesSelector: string;
  secondsSelector: string;
}

export class ProductComingSoonCountdown {
  static defaults = {
    dataKey: 'countdown',
    daysSelector: '[data-days]',
    hoursSelector: '[data-hours]',
    minutesSelector: '[data-minutes]',
    rootSelector: '.productCSCountdown__wrapper',
    rootTitleSelector: '.productCSCountdown__title',
    secondsSelector: '[data-seconds]',
  };

  options: ProductComingSoonCountdownOptions;

  toInMiliseconds: number;
  nowInMiliseconds: number;

  interval: any;

  rootElement: HTMLElement;
  rootTitleElement: HTMLElement;
  daysElement: HTMLElement;
  hoursElement: HTMLElement;
  minutesElement: HTMLElement;
  secondsElement: HTMLElement;

  daysValue: number;
  hoursValue: number;
  minutesValue: number;
  secondsValue: number;

  constructor(options?: Options) {
    this.options = {
      ...ProductComingSoonCountdown.defaults,
      ...options,
    };

    const rootElement = document.querySelector(
      this.options.rootSelector,
    ) as HTMLElement;
    if (!rootElement) {
      return;
    }
    this.rootElement = rootElement;

    const rootTitleElement = document.querySelector(
      this.options.rootTitleSelector,
    ) as HTMLElement;
    if (!rootTitleElement) {
      return;
    }
    this.rootTitleElement = rootTitleElement;

    const daysElement = document.querySelector(
      this.options.daysSelector,
    ) as HTMLElement;
    const hoursElement = document.querySelector(
      this.options.hoursSelector,
    ) as HTMLElement;
    const minutesElement = document.querySelector(
      this.options.minutesSelector,
    ) as HTMLElement;
    const secondsElement = document.querySelector(
      this.options.secondsSelector,
    ) as HTMLElement;
    if (!daysElement || !hoursElement || !minutesElement || !secondsElement) {
      return;
    }
    this.daysElement = daysElement;
    this.hoursElement = hoursElement;
    this.minutesElement = minutesElement;
    this.secondsElement = secondsElement;

    this.nowInMiliseconds = new Date().getTime();
    this.toInMiliseconds = parseInt(
      this.rootElement.dataset[this.options.dataKey] || '',
      10,
    );

    if (this.toInMiliseconds - this.nowInMiliseconds < 0) {
      this.rootElement.style.display = 'none';
      this.rootTitleElement.style.display = 'none';
      return;
    }

    this.bind();
  }

  bind() {
    this.interval = setInterval(() => {
      this.nowInMiliseconds = new Date().getTime();

      const distance = this.toInMiliseconds - this.nowInMiliseconds;

      if (distance < 0) {
        clearInterval(this.interval);
        window.location.reload();
        return;
      }

      this.daysValue = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hoursValue = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      this.minutesValue = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60),
      );
      this.secondsValue = Math.floor((distance % (1000 * 60)) / 1000);

      this.daysElement.innerHTML = `${this.daysValue}`;
      this.hoursElement.innerHTML = `${this.hoursValue}`;
      this.minutesElement.innerHTML = `${this.minutesValue}`;
      this.secondsElement.innerHTML = `${this.secondsValue}`;
    }, 1000);
  }
}
